import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  {
    name: "resident_id",
    label: "Resident",
    required: true,
    showInTable: true,
    lookup: {
      table: "residents",
      labelField: "full_name",
      secondaryField: "resident_code",
    },
  },
  {
    name: "date_of_death",
    label: "Date of Death",
    type: "date",
    showInTable: true,
  },
  { name: "time_of_death", label: "Time of Death", type: "time" },
  { name: "place", label: "Place", showInTable: true },
  { name: "cause", label: "Cause" },
  { name: "ritual_type", label: "Ritual Type" },
  { name: "ritual_date", label: "Ritual Date", type: "date" },
  { name: "ritual_location", label: "Ritual Location" },
  { name: "ritual_expense", label: "Ritual Expense", type: "number" },
  { name: "ritual_donation", label: "Ritual Donation", type: "number" },
  { name: "ritual_performed", label: "Performed (true/false)" },
  {
    name: "family_informed",
    label: "Family Informed (true/false)",
    showInTable: true,
  },
  { name: "certificate_url", label: "Certificate URL", type: "url" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export default function Page() {
  return (
    <AdminShell
      title="Resident Deaths"
      subtitle="Death records & ritual tracking"
    >
      <ResourceTable
        table="resident_death"
        title="Death Record"
        fields={fields}
        searchFields={["place", "cause", "ritual_type"]}
        orderBy="date_of_death"
      />
    </AdminShell>
  );
}
